(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wb-collection-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__wbLoadMore) return;
  window.__wbLoadMore = true;
  var SECTION = '[data-section-type="collection"]';
  function setup() {
    var section = document.querySelector(SECTION);
    if (!section) return;
    var pag = section.querySelector('.Pagination');
    if (!pag || pag.hasAttribute('data-wb-enhanced')) return;
    pag.setAttribute('data-wb-enhanced', '1');
    var next = pag.querySelector('a[rel="next"]');
    pag.style.display = 'none';
    if (!next) return;
    var nextUrl = next.getAttribute('href');
    var wrap = document.createElement('div');
    wrap.className = 'wb-loadmore';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'Button Button--secondary wb-loadmore__btn';
    btn.textContent = 'Load more';
    wrap.appendChild(btn);
    pag.parentNode.insertBefore(wrap, pag);
    var loading = false;
    var io = null;
    function finish() {
      loading = false;
      btn.disabled = false;
      btn.textContent = 'Load more';
    }
    function load() {
      if (loading || !nextUrl) return;
      loading = true;
      btn.disabled = true;
      btn.textContent = 'Loading';
      fetch(nextUrl, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newList = doc.querySelector(SECTION + ' .ProductList');
        var list = section.querySelector('.ProductList');
        if (newList && list) {
          Array.prototype.slice.call(newList.children).forEach(function (cell) {
            list.appendChild(document.importNode(cell, true));
          });
        }
        var newNext = doc.querySelector(SECTION + ' .Pagination a[rel="next"]');
        nextUrl = newNext ? newNext.getAttribute('href') : null;
        finish();
        if (!nextUrl) {
          if (io) io.disconnect();
          wrap.parentNode && wrap.parentNode.removeChild(wrap);
        }
        document.dispatchEvent(new CustomEvent('wb:loadmore', { bubbles: true }));
      }).catch(function () {
        finish();
        window.location.href = nextUrl;
      });
    }
    btn.addEventListener('click', load);
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) load();
      }, { rootMargin: '700px 0px' });
      io.observe(wrap);
    }
  }
  function boot() {
    setup();
    var section = document.querySelector(SECTION);
    if (section && 'MutationObserver' in window) {
      new MutationObserver(function () { setup(); }).observe(section, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

  } catch(e) { console.error(e); }
})();
})();
